import { useEffect } from "react";
import "../css/page/Home.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper";
import { useLocation, useNavigate } from "react-router-dom";

import styled from "styled-components";
import Img_Manufacture1 from "../assets/img/home/manufacture1.jpg";
import Img_Manufacture2 from "../assets/img/home/manufacture2.jpg";
import Img_Manufacture3 from "../assets/img/home/manufacture3.jpg";
import Img_Manufacture4 from "../assets/img/home/manufacture4.jpg";
import Img_Product1 from "../assets/img/home/product1.jpg";
import Img_Product2 from "../assets/img/home/product2.jpg";
import Img_AttachmentBack from "../assets/img/home/attachment_back.jpg";
import Img_Swipe1 from "../assets/img/home/swipe1.png";
import Img_Swipe2 from "../assets/img/home/swipe2.png";

import useResize from "../custom_hooks/useResize.tsx";
import AOS from "aos";
import "aos/dist/aos.css";
import "../css/lib/imagehover.min.css";
import INFO from "../setting/INFO";

const Main = styled.div`
  width: 100%;
  // padding-top: 83px;
  background-color: #fff;

  @media screen and (max-width: 750px) {
    padding-top: 60px;
  }
`;

const Wrapper = styled.div`
  width: 100%;
  position: relative;
  background-size: cover;

  &.swiper {
    aspect-ratio: 16/9;
    max-height: 700px;
  }
  &.introduction {
    padding: 35px 0 50px 0;
    text-align: center;
  }

  &.product_introduction {
    background-color: #fff;
  }

  @media (max-width: 500px) {
    .introduction h1 {
      font-size: 26px;
    }
    .product_introduction div.sub-title {
      font-size: 14px;
    }
    .glass_introduction div.sub-title {
      font-size: 14px;
    }
  }
`;

const SwipeText = styled.span`
  width: 100%;
  color: #fff;
  font-family: "NotoSans";
  font-size: 3vw;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  line-height: 1.8;
  z-index: 10;
  font-family: "NotoSansBold";
  font-size: 3.6vw;

  @media (max-width: 900px) {
    font-size: 5vw;
  }
`;

const Title = styled.h1`
  color: ${INFO.THEME_COLOR};
  font-family: "NanumGothicBold";
  font-size: 39px;
  border-bottom: 2px solid #999;
  width: fit-content;
  padding: 20px;
  display: inline-block;
  margin: 0;
  z-index: 1;
  position: relative;
`;

const SubTitle = styled.div`
  color: #000000;
  font-family: "NanumGothicBold";
  font-size: 19px;
  margin-top: 17px;
  line-height: 1.6;
  padding: 0 25px;
  z-index: 1;
  position: relative;
`;

const IconMainContainer = styled.div``;

const IconCotainer = styled.div`
  display: inline-block;
  position: relative;
  width: 260px;
  height: 300px;
  margin: 50px 10px 0px 10px;
  text-align: center;
  cursor: pointer;

  &:hover {
    opacity: 0.7 !important;
    transform: scale(1.1) !important;
    transition: 0.3s !important;
  }
  &:hover .overlay {
    opacity: 1 !important;
    transition: 0.3s !important;
  }

  @media (max-width: 1030px) {
    width: 45%;
  }
  @media (max-width: 500px) {
    width: 100%;
    margin-left: 0px;
    margin-right: 0px;
  }
`;

const IconLink = styled.a`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const IconSubCotainer = styled.div`
  display: inline-block;
  max-width: 260px;
`;
const Icon = styled.div`
  display: inline-block;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(${(props) => props.src});
`;
const Overlay = styled.div`
  display: inline-block;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;
const IconDescContainer = styled.article``;

const DescTitle = styled.h2`
  font-size: 20px;
  color: #000000;
  margin: 22px 0 0 0;
  font-family: "NanumGothic";
`;
const Description = styled.h3`
  font-family: "NanumGothic";
  color: #000000;
  font-size: 14px;
  margin-top: 8px;
  line-height: 18px;
`;

const AttachmentScreen = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  background-color: #ffffff76;
  width: 100%;
  height: 100%;
  z-index: 0;
`;
const ShutterContainer = styled.figure`
  width: 230px;
  height: 323px;
  cursor: pointer;
  padding: 20px;
  margin: 40px 25px 0 25px;
  background-color: #ffffff42;

  &:before,
  &:after {
    background: #2a3f72 !important;
  }
`;
const Shutter = styled.figcaption`
  background-color: #2a3f72 !important;
  text-align: left;
  line-height: 2;
  font-size: 17px;
  font-family: "NanumGothicBold";
`;
const ShutterImg = styled.img`
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 190px;
  height: 240px;
`;
const ShutterLink = styled.a``;

const MapContainer = styled.div`
  margin-top: 30px;
  padding: 0 50px;
  display: flex;
  justify-content: center;

  @media (max-width: 900px) {
    display: block;
    text-align: center;
    padding: 0 15px;
  }
`;
const GoogleMap = styled.div`
  flex: 1;
  overflow: hidden;
  position: relative;
  display: inline-block;
  min-width: 470px;
  height: 400px;

  & iframe {
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    position: absolute;
  }

  @media (max-width: 900px) {
    width: 100%;
    min-width: 0px;
  }
`;
const MapDescription = styled.article`
  display: inline-block;
  width: 430px;
  text-align: left;
  margin-top: 30px;
  margin-left: 70px;

  @media (max-width: 900px) {
    display: block;
    width: 100%;
    margin-top: 30px;
    margin-left: 0;
    text-align: center;
  }
`;
const MapDescriptionTitle = styled.h2`
  margin-bottom: 10px;
  color: #1a5194;
  font-family: "NanumGothicBold";
  letter-spacing: 2px;
`;
const MapDescriptionTitleHr = styled.hr`
  border-top: 1px solid #ccc;
`;
const MapDescriptionRow = styled.span`
  display: block;
  margin-top: 3px;
  color: #999;
  font-size: 16px;
`;
const Div = styled.div`
  display: inline-block;
`;

export default function Home() {
  const isMobile = useResize() <= 750;
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init();
  });

  const clickLink = (link) => {
    navigate(link);
    window.scrollTo({ top: 0, left: 0 });
    document.querySelector(".heaher-main-li.hover")?.classList.remove("hover");
  };

  const aniProps = (direction) => {
    return {
      "data-aos": `fade-${direction}`,
      "data-aos-duration": 1500,
    };
  };

  return (
    <Main>
      <Wrapper className="swiper">
        <Swiper pagination={true} modules={[Pagination]} className="mySwiper" loop={true} style={{ maxHeight: 700 }}>
          <SwiperSlide>
            <img src={Img_Swipe1} />
          </SwiperSlide>
          <SwiperSlide>
            <img src={Img_Swipe2} />
          </SwiperSlide>
        </Swiper>
      </Wrapper>

      <Wrapper className="introduction product_introduction">
        <Title>큰제목1</Title>
        <SubTitle className="sub-title">설명1</SubTitle>
        <IconMainContainer>
          <IconCotainer>
            <Div {...aniProps("up")}>
              <IconLink
                onClick={() => {
                  clickLink("/manufacture");
                }}
              ></IconLink>
              <IconSubCotainer>
                <Icon src={Img_Manufacture1}>
                  <Overlay className="overlay"></Overlay>
                </Icon>
                <IconDescContainer>
                  <DescTitle>상품1</DescTitle>
                </IconDescContainer>
              </IconSubCotainer>
            </Div>
          </IconCotainer>

          <IconCotainer>
            <Div {...aniProps("up")}>
              <IconLink
                onClick={() => {
                  clickLink("/manufacture");
                }}
              ></IconLink>
              <IconSubCotainer>
                <Icon src={Img_Manufacture2}>
                  <Overlay className="overlay"></Overlay>
                </Icon>
                <IconDescContainer>
                  <DescTitle>상품2</DescTitle>
                </IconDescContainer>
              </IconSubCotainer>
            </Div>
          </IconCotainer>

          <IconCotainer>
            <Div {...aniProps("up")}>
              <IconLink
                onClick={() => {
                  clickLink("/manufacture");
                }}
              ></IconLink>
              <IconSubCotainer>
                <Icon src={Img_Manufacture3}>
                  <Overlay className="overlay"></Overlay>
                </Icon>
                <IconDescContainer>
                  <DescTitle>상품3</DescTitle>
                </IconDescContainer>
              </IconSubCotainer>
            </Div>
          </IconCotainer>

          <IconCotainer>
            <Div {...aniProps("up")}>
              <IconLink
                onClick={() => {
                  clickLink("/manufacture");
                }}
              ></IconLink>
              <IconSubCotainer>
                <Icon src={Img_Manufacture4}>
                  <Overlay className="overlay"></Overlay>
                </Icon>
                <IconDescContainer>
                  <DescTitle>상품4</DescTitle>
                </IconDescContainer>
              </IconSubCotainer>
            </Div>
          </IconCotainer>
        </IconMainContainer>
      </Wrapper>

      <Wrapper
        className="introduction glass_introduction"
        style={{
          backgroundImage: `url(${Img_AttachmentBack})`,
          backgroundSize: "cover",
          backgroundAttachment: "fixed",
        }}
      >
        {/* <AttachmentBackground />
         */}
        <AttachmentScreen />
        <Title>제품소개</Title>
        <SubTitle className="sub-title">- 제품 소개 설명 -</SubTitle>
        <IconMainContainer>
          <Div {...aniProps("up")}>
            <ShutterContainer className="imghvr-shutter-in-out-horiz">
              <ShutterImg src={Img_Product1} />
              <Shutter>
                - 설명1
                <br />- 설명2
                <br />- 설명3
                <br />- 설명4
              </Shutter>
              <IconDescContainer>
                <DescTitle>제품1</DescTitle>
              </IconDescContainer>
              <ShutterLink
                onClick={() => {
                  clickLink("/production/product1");
                }}
              />
            </ShutterContainer>
          </Div>

          <Div {...aniProps("up")}>
            <ShutterContainer className="imghvr-shutter-in-out-horiz">
              <ShutterImg src={Img_Product2} />
              <Shutter>
                - 설명1
                <br />- 설명2
                <br />- 설명3
                <br />- 설명4
              </Shutter>
              <IconDescContainer>
                <DescTitle>제품2</DescTitle>
              </IconDescContainer>
              <ShutterLink
                onClick={() => {
                  clickLink("/production/product2");
                }}
              />
            </ShutterContainer>
          </Div>
        </IconMainContainer>
      </Wrapper>

      <Wrapper className="introduction contact" {...aniProps("up")}>
        <Title>오시는 길</Title>
        <MapContainer>
          <GoogleMap className="google-map">
            <iframe
              src={INFO.GOOGLE_LOCATION}
              width="600"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </GoogleMap>
          <MapDescription>
            <MapDescriptionTitle>LOCATION</MapDescriptionTitle>
            <MapDescriptionTitleHr />
            <MapDescriptionRow>주소 : {INFO.COMPANY_NAME}</MapDescriptionRow>
            <MapDescriptionRow>전화 : {INFO.COMPANY_PHONE}</MapDescriptionRow>
            <MapDescriptionRow>팩스 : {INFO.COMPANY_PAX}</MapDescriptionRow>
            <MapDescriptionRow>이메일 : {INFO.COMPANY_EMAIL}</MapDescriptionRow>
            <MapDescriptionRow>시간 : {INFO.WORKING_TIME}</MapDescriptionRow>
          </MapDescription>
        </MapContainer>
      </Wrapper>
    </Main>
  );
}
